module.exports = __webpack_public_path__ + "static/media/david-breuer_it-consultant-jamstack-architect.c81148e3.png";